if (!customElements.get('sticky-atc-bar')) {
  class StickyAtcBar extends HTMLElement {
    connectedCallback() {
      this.productType = this.dataset.productType;
      this.buyPanelSelector = this.dataset.buyPanel || '[data-sticky-buy-panel]';

      const variantsEl = this.querySelector('[data-sticky-variants]');
      this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

      this.priceEl = this.querySelector('[data-sticky-price]');
      this.compareEl = this.querySelector('[data-sticky-compare]');
      this.atcBtn = this.querySelector('[data-sticky-atc]');
      this.scrollBtn = this.querySelector('[data-sticky-scroll]');

      this._label = null;
      this._available = false;

      this._setupVisibility();
      this._setupInteractions();

      if (this.productType === 'membership') {
        this._setupMembership();
      } else {
        this._setupStandard();
      }
    }

    _setupVisibility() {
      const target = document.querySelector(this.buyPanelSelector);
      if (!target) return;

      this._footerVisible = false;

      const footer = document.querySelector('.site-footer');
      if (footer) {
        new IntersectionObserver(entries => {
          this._footerVisible = entries[0].isIntersecting;
          this._updateVisibility(target);
        }, { threshold: 0 }).observe(footer);
      }

      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          this._buyPanelEntry = entry;
          this._updateVisibility(target);
        });
      }, { threshold: 1 });

      io.observe(target);
    }

    _updateVisibility(target) {
      const entry = this._buyPanelEntry;
      if (!entry) return;
      const isAbove = window.scrollY < target.offsetTop;
      const show = !entry.isIntersecting && !isAbove && !this._footerVisible;
      this.classList.toggle('is-visible', show);
      this._toggleGorgias(!show);
    }

    _setupInteractions() {
      this.atcBtn?.addEventListener('click', () => {
        const realBtn = document.querySelector('[data-action="add-to-cart"], [data-add-to-cart]');
        if (realBtn && !realBtn.disabled) realBtn.click();
      });

      this.scrollBtn?.addEventListener('click', () => {
        const target = document.querySelector(this.buyPanelSelector);
        const scrollTarget = target?.closest('membership-product, form, [data-product-content]') || target;
        if (!scrollTarget) return;

        const headerOffset = 80;
        const top = scrollTarget.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top, behavior: 'smooth' });

        if (typeof gtag === 'function') {
          gtag('event', 'sticky_ATC_click', {
            event_category: 'experiments',
            event_action: 'stickyATC',
            value: 1
          });
        }
      });
    }

    _setupMembership() {
      const component = document.querySelector('membership-product');
      if (!component) return;

      const mainSelect = component.querySelector('[data-main-select]');
      const radios = component.querySelectorAll('input[type="radio"]');

      if (mainSelect?.value) this._onVariantChange(parseInt(mainSelect.value));

      const checkedRadio = Array.from(radios).find(r => r.checked);
      if (checkedRadio) this._updateOption(checkedRadio.value);

      mainSelect?.addEventListener('change', () => {
        this._onVariantChange(parseInt(mainSelect.value));
      });

      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.checked) this._updateOption(radio.value);
        });
      });
    }

    _setupStandard() {
      document.addEventListener('variant:change', e => {
        const { variant } = e.detail || {};
        if (variant) this._onVariantChange(variant.id);
      });

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      if (variantId) {
        this._onVariantChange(parseInt(variantId));
      } else if (this.variants.length) {
        const first = this.variants.find(v => v.available) || this.variants[0];
        this._onVariantChange(first.id);
      }
    }

    _onVariantChange(variantId) {
      const variant = this.variants.find(v => v.id === variantId);
      if (!variant) return;

      if (this.priceEl) this.priceEl.textContent = this._formatMoney(variant.price);

      if (this.compareEl) {
        const hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.compareEl.textContent = hasDiscount ? this._formatMoney(variant.compare_at_price) : '';
        this.compareEl.hidden = !hasDiscount;
      }

      this._available = variant.available;

      if (this.productType !== 'membership') {
        this._label = variant.title && variant.title !== 'Default Title' ? variant.title : null;
      }

      this._updateButton();
    }

    _updateOption(value) {
      this._label = value;
      this._updateButton();
    }

    _updateButton() {
      if (!this.atcBtn) return;
      this.atcBtn.disabled = !this._available;
      const strings = window.theme?.strings || {};
      this.atcBtn.textContent = !this._available
        ? strings.soldOut || 'Sold Out'
        : this._label
          ? (strings.startWith || 'Start with [label]').replace('[label]', this._label)
          : strings.addToCart || 'Add to Cart';
    }

    _toggleGorgias(visible) {
      const chatButton = document.getElementById('chat-button');
      const chatInput = document.getElementById('chat-input');
      if (chatButton) chatButton.style.display = visible ? '' : 'none';
      if (chatInput) chatInput.style.display = visible ? '' : 'none';
    }

    _formatMoney(cents) {
      const dollars = cents / 100;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: dollars % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(dollars);
    }
  }

  customElements.define('sticky-atc-bar', StickyAtcBar);
}
